export const co2PerKwh = 0.025 // Updated as of 10.6.2026 https://www.fingrid.fi/en/electricity-market-information/real-time-co2-emissions-estimate Can be used to update
export const _syneString_ = 'YYYY-MM-DDTHH:mm:ss'
export const defaultLatitude = 62.402698
export const defaultLongitude = 23.858187
export const defaultVat = 0.255 // 25.5% VAT in Finland
export const minAcceptedHvacTemperature = 15
export const maxAcceptedHvacTemperature = 28
export const billAmountThreshold = 5 // The threshold at which we start sending invoices to customers. This is to avoid sending invoices for very small amounts.
export const electricTaxPerKwh = 2.917875 // Electric tax in Finland as of 1.4.2026
